import React from 'react';
import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';
import { Box, Card, Flex, Image, Link, Text, getPaletteColor } from 'pcln-design-system';
import { ArrowRight, ChevronRight } from 'pcln-icons';
const MAX_MEDIA_SIZE = 72;
const FlexCard = /*#__PURE__*/styled(Card).withConfig({
  displayName: "ActionCard__FlexCard",
  componentId: "sc-p9iexd-0"
})(["display:flex;flex-direction:row;align-items:center;border:none;box-shadow:", ";cursor:", ";", ";&:hover{box-shadow:", ";}"], props => props.onClick ? themeGet('shadows.sm') : 'none', props => props.onClick ? 'pointer' : 'default', props => props.disabled && `
    background-color: ${getPaletteColor('background.light')(props)};
    box-shadow: none;
    cursor: default;
    &:hover {
      box-shadow: none;
    }
  `, props => props.onClick ? themeGet(`shadows.${props.hoverBoxShadowSize || 'xl'}`) : 'none');
const Heading = /*#__PURE__*/styled(Text).withConfig({
  displayName: "ActionCard__Heading",
  componentId: "sc-p9iexd-1"
})(["", ""], props => props.width && `
    white-space: ${props.shouldWrap ? 'normal' : 'nowrap'};
    overflow: hidden;
    text-overflow: ellipsis;
  `);
const StyledArrowRight = /*#__PURE__*/styled(ArrowRight).withConfig({
  displayName: "ActionCard__StyledArrowRight",
  componentId: "sc-p9iexd-2"
})(["", ""], props => props.disabled && `color: ${getPaletteColor('text.light')(props)};`);
/** @public */
function ActionCard({
  actionText,
  caption,
  className,
  disabled,
  handleSubmitCTA,
  heading,
  headingTextTransform = 'none',
  headingWidth,
  hoverBoxShadowSize,
  icon,
  imageAlt,
  imageUrl,
  isIconRounded = true,
  onClick,
  overline,
  shouldWrap = false
}) {
  const iconColor = disabled ? 'text.light' : icon && icon.props.color || 'primary';
  const iconBgColor = disabled ? 'background.tint' : iconColor && `${iconColor.split('.')[0]}.light`;
  const iconSize = isIconRounded ? 24 : 32;
  const iconWrapperSize = isIconRounded ? 48 : MAX_MEDIA_SIZE;
  const iconWrapperRadius = isIconRounded ? 'full' : 'xl';
  function handleKeyDown(e) {
    if (handleSubmitCTA && e.key === 'Enter') {
      handleSubmitCTA(e);
    }
  }
  return React.createElement(FlexCard, {
    "data-testid": 'action-card',
    borderRadius: 'xl',
    className: className,
    color: 'background.lightest',
    disabled: disabled,
    hoverBoxShadowSize: hoverBoxShadowSize,
    minHeight: MAX_MEDIA_SIZE,
    p: 2,
    role: onClick || handleSubmitCTA ? 'link' : '',
    tabIndex: (onClick || handleSubmitCTA) && !disabled ? '0' : '-1',
    onClick: !disabled && onClick,
    onKeyDown: !disabled && handleKeyDown
  }, icon && React.createElement(Box, null, React.createElement(Flex, {
    alignItems: 'center',
    borderRadius: iconWrapperRadius,
    color: iconBgColor,
    justifyContent: 'center',
    height: iconWrapperSize,
    width: iconWrapperSize,
    mr: 1
  }, React.cloneElement(icon, {
    color: iconColor,
    size: iconSize
  }))), imageUrl && React.createElement(Image, {
    alt: imageAlt,
    borderRadius: 'xl',
    src: imageUrl,
    width: MAX_MEDIA_SIZE,
    height: MAX_MEDIA_SIZE,
    mr: 1
  }), React.createElement(Flex, {
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%'
  }, React.createElement(Flex, {
    flexDirection: 'column',
    mx: 2
  }, overline && React.createElement(Text, {
    color: 'text.light',
    textStyle: 'caption',
    mb: 1
  }, overline), React.createElement(Heading, {
    color: disabled && 'text.light',
    fontWeight: 'bold',
    textStyle: 'heading6',
    textTransform: headingTextTransform,
    width: headingWidth,
    shouldWrap: shouldWrap
  }, heading), caption && React.createElement(Text, {
    color: disabled && 'text.light',
    textStyle: 'caption',
    mt: 1
  }, caption), actionText && React.createElement(Link, {
    disabled: disabled,
    onClick: onClick,
    mt: 1
  }, React.createElement(Flex, {
    alignItems: 'center'
  }, React.createElement(Text, {
    textStyle: 'caption'
  }, actionText), React.createElement(ChevronRight, {
    width: 20,
    height: 20,
    ml: 2
  }))))), !actionText && onClick && React.createElement(StyledArrowRight, {
    color: 'primary',
    disabled: disabled,
    size: 20,
    title: 'ArrowRight'
  }));
}
export default ActionCard;